import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { Breadcrumbs } from '~/ui/core/breadcrumbs/Breadcrumbs';

import { SkeletonBreadcrumbs } from '../components/SkeletonLoaders';
import { useProfileBreadcrumbs } from '../hooks/use-profile-breadcrumbs';

type ProfileBreadcrumbsProps = {
    readonly architectureId: string;
    readonly clusterId: string;
    readonly currentItemTitle: string;
    readonly familyId: string;
    readonly parentRoleId?: string | undefined;
};

export const ProfileBreadcrumbs: FunctionComponent<ProfileBreadcrumbsProps> = ({
    architectureId,
    clusterId,
    currentItemTitle,
    familyId,
    parentRoleId,
}) => {
    const { breadcrumbItems, isLoading } = useProfileBreadcrumbs({
        architectureId,
        clusterId,
        currentItemTitle,
        familyId,
        parentRoleId,
    });

    if (isLoading) {
        return <SkeletonBreadcrumbs />;
    }

    if (is.emptyArray(breadcrumbItems)) {
        return null;
    }

    return (
        <div className="[&>div>div>span]:!text-gray-500 [&>div>div>button]:!text-gray-500 [&>div>div>button]:transition-colors [&>div>div>button]:duration-200 [&>div>div>button]:[transition-timing-function:ease] [&>div>div>button:hover]:!text-gray-700 [&>div>div>svg]:!text-gray-400">
            <Breadcrumbs items={breadcrumbItems} />
        </div>
    );
};
